import { render, staticRenderFns } from "./GovernmentRotaOrder.vue?vue&type=template&id=efe7f852"
import script from "./GovernmentRotaOrder.vue?vue&type=script&lang=js"
export * from "./GovernmentRotaOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports